﻿export async function pageCheckReload(currentUrl) {
    try {
        if (window.location.pathname.toLowerCase().startsWith('/notfound'))
            return;
        const response = await fetch(currentUrl);
        if (response.ok) {
            window.location.reload();
        }
    } catch (error) {
        console.error("Lỗi kiểm tra URL:", error);
    }
}